import styled from "styled-components";

const SearchLabel = styled.div`
    display:flex;
    justify-content: space-between;
    align-items: center;
`
export default SearchLabel;